import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";

import Footer from "../components/Footer";
import DFNavbar from "../components/Navbar";
import dfscanner_top_img from "./../img/dfscanner/screen.png";
import dflat_top_img from "./../img/dflat/screen.png";
import dfviewer_top_img from "./../img/dfviewer/screen.png";
import dfwalker_top_img from "./../img/dfwalker/screen_2.png";
import dfbird_top_img from "./../img/dfbird/screen.png";
import { useUserContext } from "../contexts/UserContext";
import { MYPAGE_ROUTE, SIGNIN_ROUTE } from "../consts/routes";
import { ScrollToTop } from "../components/ScrollToTop";
import { Helmet } from "react-helmet";
import i18n from "../i18n/configs";

/**
 * トップ画面
 * @returns JSX.Element
 */
const Top = () => {
    const { t } = useTranslation();
    const { user } = useUserContext();

    // 商品紹介パネル定義
    const cards = [
        {
            imageSrc: dfscanner_top_img,
            subtitle: t("Top.dfscannerHeader"),
            title: "DF Scanner",
            description: t("Top.dfscannerText"),
            urlJp: "https://deepforest-tech.co.jp/df-scanner/",
            urlEn: "https://deepforest-tech.co.jp/en/df-scanner/",
        },
        {
            imageSrc: dflat_top_img,
            subtitle: t("Top.dflatHeader"),
            title: "DF LAT",
            description: t("Top.dflatText"),
            urlJp: "https://deepforest-tech.co.jp/df-lat/",
            urlEn: "https://deepforest-tech.co.jp/en/df-lat/",
        },
        {
            imageSrc: dfviewer_top_img,
            subtitle: t("Top.dfviewerHeader"),
            title: "DF Viewer",
            description: t("Top.dfviewerText"),
            urlJp: "http://deepforest-tech.co.jp/df-viewer/",
            urlEn: "http://deepforest-tech.co.jp/en/df-viewer/",
        },
        {
            imageSrc: dfbird_top_img,
            subtitle: t("Top.dfbirdHeader"),
            title: "DF BIRD",
            description: t("Top.dfbirdText"),
            urlJp: "https://deepforest-tech.co.jp/df-bird/",
            urlEn: "https://deepforest-tech.co.jp/en/df-bird/",
        },
        {
            imageSrc: dfwalker_top_img,
            subtitle: t("Top.dfwalkerHeader"),
            title: "DF Walker",
            description: t("Top.dfwalkerText"),
            urlJp: "https://deepforest-tech.co.jp/df-walker/",
            urlEn: "https://deepforest-tech.co.jp/en/df-walker/",
        },
    ];

    return (
        <div className="flex min-h-screen flex-col">
            <Helmet>
                <title>{t("Top.meta.title")}</title>
                <meta name="description" content={t("Top.meta.description")} />
            </Helmet>
            <ScrollToTop />
            <DFNavbar bottomPadding={false} />
            <div
                className="min-h-144 relative h-screen bg-cover bg-center"
                style={{
                    backgroundImage: 'url("/images/background.png")',
                }}
            >
                <div className="absolute inset-0 z-10 bg-black opacity-70"></div>
                <div className="relative z-20 mx-auto flex h-full flex-col px-6 sm:px-8">
                    <div className="flex flex-1 flex-col items-center justify-center px-4">
                        {/* トップ見出し */}
                        <h1 className="-mt-24 text-center text-3xl font-black leading-snug text-gray-100 sm:mt-0 sm:text-4xl lg:text-5xl xl:text-6xl">
                            <span className="mt-2 inline-block font-black">DF WebService</span>
                            <br />
                            <span className="mt-2 inline-block text-lg sm:text-xl lg:text-xl xl:text-3xl">
                                Powered by DeepForest Technologies
                            </span>
                        </h1>

                        {/* サービスメニューへ */}
                        <Link to={user ? MYPAGE_ROUTE : SIGNIN_ROUTE}>
                            <button className="mt-10 rounded-full bg-lime-700 px-8 py-3 text-sm font-bold text-gray-200 shadow transition duration-300 hover:bg-lime-900 hover:text-gray-200 focus:outline-none sm:mt-16 sm:px-8 sm:py-4 sm:text-lg">
                                {t("Top.dfaccountMenu")}
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="relative overflow-x-hidden bg-slate-50">
                <div className="mx-auto max-w-screen-xl py-20 lg:py-24">
                    <div className="flex flex-col items-center">
                        <h2 className="text-center text-4xl font-black tracking-wide text-gray-900 sm:text-5xl">
                            Applications
                        </h2>
                        <p className="mt-4 max-w-lg text-center font-medium text-gray-600">
                            {t("Top.applicationText")}
                        </p>
                    </div>

                    <div className="mt-16 space-y-24">
                        {cards.map((card, index) => (
                            <div
                                key={index}
                                className={`flex flex-col lg:flex-row ${
                                    index % 2 === 1 ? "lg:flex-row-reverse" : ""
                                } items-center justify-center`}
                            >
                                <img src={card.imageSrc} alt="Event image" className="h-auto w-full max-w-md rounded" />
                                <div
                                    className={`mx-4 mt-6 max-w-lg lg:mt-0 ${index % 2 === 1 ? "lg:mr-8" : "lg:ml-8"}`}
                                >
                                    <span className="font-bold uppercase tracking-wider text-lime-600">
                                        {card.subtitle}
                                    </span>
                                    <h4 className="text-3xl font-bold text-gray-800">{card.title}</h4>
                                    <p className="mt-2 text-sm font-bold leading-relaxed text-gray-500">
                                        {card.description}
                                    </p>
                                    <a
                                        href={i18n.language === "ja" ? card.urlJp : card.urlEn}
                                        className="link-text mt-4 inline-block border-b-2 border-transparent text-sm font-bold"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {t("Top.moreInfo")}
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Top;
